export default __webpack_public_path__ + "static/media/doctor.84c1b154.png";